import styled from "@emotion/styled";
import {
  Container as FollowUsOnFacebookContainer,
  Description as FollowUsOnFacebookDescription,
} from "scmp-sdk/components/follow-us-on-facebook/styles";
import { SubmitButton as SignUpButtonSubmitButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button/styles";
import {
  Container as SocialButtonContainer,
  IconContainer as SocialButtonIconContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import {
  ActionContainer as SignUpNewsletterActionContainer,
  AgreementCheckboxContainer as SignUpNewsletterAgreementCheckboxContainer,
  AgreementContainer as SignUpNewsletterAgreementContainer,
  Container as SignUpNewsletterContainer,
  SummaryContainer as SignUpNewsletterSummaryContainer,
  TermAndConditionContainer as SignUpNewsletterTermAndConditionContainer,
  Title as SignUpNewsletterTitle,
  TitleContainer as SignUpNewsletterTitleContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import {
  CheckEmailMessage as SignUpSuccessCheckEmailMessage,
  Container as SignUpSuccessContainer,
  IconContainer as SignUpSuccessIconContainer,
  Title as SignUpSuccessTitle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontMerriweather, fontRoboto, theme as mediaTheme } from "shared/lib/styles";

export const theme: ThemeType = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "white",
  },
  orientation: "landscape",
  root: {
    containerSize: "medium",
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: true,
    summaryFontStyle: "medium",
    titleFontStyle: "small",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: true,
    hasSeeMoreLinks: false,
    titleFontStyle: "medium",
  },
};

type ContainerProps = {
  theme?: ThemeType;
};

export const Container = styled.div<ContainerProps>`
  ${SignUpNewsletterContainer} {
    place-items: center center;

    text-align: start;

    ${SignUpNewsletterTitleContainer} {
      margin-block-end: 5px;
    }
    ${SignUpNewsletterTitle} {
      max-inline-size: 382px;

      color: #001246;
      font-size: 18px;
      font-family: ${fontMerriweather};
      line-height: 23px;
      text-align: center;
    }

    ${SignUpNewsletterSummaryContainer},
    ${SignUpNewsletterAgreementContainer},
    ${SignUpNewsletterTitleContainer} {
      ${mediaTheme.breakpoints.up("tablet")} {
        justify-self: flex-start;
      }
    }

    ${SignUpNewsletterTermAndConditionContainer} {
      ${mediaTheme.breakpoints.down("tablet")} {
        text-align: center;
      }
    }

    ${SignUpNewsletterAgreementContainer} {
      align-items: center;
    }
    ${SignUpNewsletterAgreementCheckboxContainer} {
      display: flex;
    }
    ${SignUpNewsletterActionContainer} {
      margin-block-end: 0;
    }
  }

  ${SignUpSuccessContainer} {
    grid-template-areas:
      "Icon Title"
      "Icon Footer";
    grid-template-columns: 25px 1fr;
    justify-items: flex-start;

    max-inline-size: 402.5px;
    margin-block: 0;
    margin-inline: auto;

    text-align: start;

    ${SignUpSuccessTitle} {
      margin-block-end: 4px;

      color: #001246;
      font-weight: 400;
      font-size: 18px;
      font-family: ${fontMerriweather};
      line-height: 23px;
      ${mediaTheme.breakpoints.up("tablet")} {
        margin-block-end: 8px;
      }
    }
    ${SignUpSuccessCheckEmailMessage} {
      margin-block-end: 0;
      padding-block-start: 0;

      color: #000000;
      font-size: 14px;
      font-family: ${fontRoboto};
      line-height: 18px;
    }
    ${SignUpSuccessIconContainer} {
      margin-block-end: 0;
    }
  }

  ${SignUpButtonSubmitButton} {
    margin-block-end: 8px;
  }

  ${SocialButtonContainer} {
    justify-content: center;

    margin-block-end: 8px;
    ${mediaTheme.breakpoints.up("tablet")} {
      margin-block: 10px 0;
    }
    ${SocialButtonIconContainer} {
      background-color: #ffffff;
    }
  }

  ${FollowUsOnFacebookContainer} {
    margin-block-start: 0;
    ${FollowUsOnFacebookDescription} {
      display: flex;
      align-items: center;
    }
  }
`;
